<script lang="ts">
  import useFilter from '../hooks/use-filter'
  const { buttons } = useFilter()
</script>

<button type="button" on:click class="text-skin-primary hover:underline">
  {buttons.clear}
</button>
